/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';

let WidgetELearningModuleCompletionButton = function (config) {
    var timer = null;
    let allowCompletion = false;

    config.selector = (typeof  config.selector !== 'undefined') ?   config.selector : 'e-learning-percentage-complete';
    config.route = (typeof  config.route !== 'undefined') ?   config.route : '/widget/elearning/module/%id%/percentage-completes';
    config.btnSelector = (typeof  config.btnSelector !== 'undefined') ?   config.btnSelector : null;
    config.completionLimit = (typeof  config.completionLimit !== 'undefined') ?   config.completionLimit : 100;

    /**
     * Create the route string
     *
     * @param id
     *
     * @returns {string}
     */
    function createRoute (id) {
        return Utils.generateRouteFromPattern({
                pattern : {
                    '%id%': id
                },
                route : config.route,
                env : config.env,
                locale: config.locale
            });
    }

    let updateMenuItem = function() {
        let item = document.querySelector('.module-run .content-specific-nav .menu-item:nth-of-type(3) a');
        if (item) {
            item.onclick = function () {
                if(false === hasCompleted()) {
                    alert('You must first complete the module');
                    return false;
                }
            };
        }
    };

    let displayBtn = function() {

        if(config.btnSelector === ''){
            // console.log('Please set the btnSelector')
            return false;
        }

        document.querySelector(config.btnSelector).classList.remove('disabled');

    };

    /**
     * @param id
     */
    let getModuleStats =  function(id) {

        let route = createRoute(id);

        /**
         * Ran on AJAX success
         *
         * @param response
         */
        let success = function(response){
            // console.log(response);
            if(response.percentage_complete >= config.completionLimit){
                allowCompletion = true;
            }

            if(hasCompleted()) {
                clearTimer();
                displayBtn();
            }

            // What was this for? I think it is redundant now. That nav does not have anything which should wait until module completed.
            // updateMenuItem();
        };

        /**
         * Ran on AJAX error
         *
         * @param response
         */
        let error = function(response){
            console.log('ERROR');
            console.log(response);
        };

        if(false === hasCompleted()) {
            Ajax.getRequest(route, success, error);
        }
    };

    /**
     *
     * @param moduleID
     * @param seconds
     */
    let automateStatusCheck = function(moduleID, microseconds)
    {
         timer = setInterval(function() {
            getModuleStats(moduleID);
        }, microseconds);
    };

    /**
     *
     * @returns {boolean}
     */
    let hasCompleted = function () {
        return allowCompletion;
    };

    let clearTimer = function ()
    {
        clearInterval(timer);
    };


    return {
        automateStatusCheck: automateStatusCheck,
        getModuleStats: getModuleStats,
        hasCompleted: hasCompleted
    };

};

export default WidgetELearningModuleCompletionButton;

